<template>
    <el-dialog
            custom-class="e6-column-dialog"
            :title="$t('_private.title.tableColumnSet')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="490px"
    >
        <div class="column-wrapper" :style="{height: columnWrapperHeight}">
            <div class="column-item-wrapper column-left">
                <div class="set-column-title">{{$t('_private.title.hiddenColumn')}}</div>
                <div class="set-column-wrapper">
                    <draggable
                            class="list-group-wrapper"
                            element="div"
                            v-model="hideTableColsLocal"
                            :move="onMove"
                            :options="dragOptions"
                    >
                        <transition-group name="no" class="list-group" tag="ul">
                            <li
                                    v-for="(element, index) in hideTableColsLocal"
                                    :class="['list-group-item', {'undraggable' : element.fixable}]"
                                    :key="'hide' + index"
                            >{{element.title}}
                            </li>
                        </transition-group>
                    </draggable>
                </div>
            </div>
            <div class="column-item-wrapper column-right">
                <div class="set-column-title">{{$t('_private.title.displayColumn')}}</div>
                <div class="set-column-wrapper">
                    <draggable
                            class="list-group-wrapper"
                            element="div"
                            v-model="showTableColsLocal"
                            :move="onMove"
                            :options="dragOptions"
                    >
                        <transition-group name="no" class="list-group" tag="ul">
                            <li
                                    v-for="(element, index) in showTableColsLocal"
                                    :class="['list-group-item', {'undraggable' : element.fixable}]"
                                    :key="'show' + index"
                            >{{element.title}}
                            </li>
                        </transition-group>
                    </draggable>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="setColumnSubmit">{{$t('_private.button.confirm')}}</el-button>
            <el-button @click="setColumnCancel">{{$t('_private.button.cancel')}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import draggable from "vuedraggable";

    export default {
        name: "E6ColumnSet",
        components: {
            draggable
        },
        props: {
            columSetVisible: {
                type: Boolean,
                default: true
            },
            columnWrapperHeight: {
                type: String,
                default: "320px"
            },
            hideTableCols: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            showTableCols: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.columSetVisible;
                },
                set(v) {
                    this.updateColumSetVisible(v);
                }
            },
            hideTableColsLocal: {
                get() {
                    return this.hideTableCols;
                },
                set(v) {
                    this.$emit("update:hideTableCols", v);
                }
            },
            showTableColsLocal: {
                get() {
                    return this.showTableCols;
                },
                set(v) {
                    this.$emit("update:showTableCols", v);
                }
            },
            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost",
                    filter: ".undraggable"
                };
            }
        },
        methods: {
            updateColumSetVisible(v) {
                this.$emit("update:columSetVisible", v);
            },
            onMove({relatedContext, draggedContext}) {
                const relatedElement = relatedContext.element;
                const draggedElement = draggedContext.element;
                return (
                    (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
                );
            },
            setColumnSubmit() {
                this.updateColumSetVisible(false);
                this.$emit("setColumnSubmit");
            },
            setColumnCancel() {
                this.updateColumSetVisible(false);
                this.$emit("setColumnCancel");
            }
        }
    };
</script>
